import { CardApiClient } from './cardApiClient';
var shopUrls = {
    getShops: '/v2/shops/list',
    createShop: '/v1/shops',
    updateShop: function (id) { return "/v1/shops/" + id; },
    destroyShop: function (id) { return "/v1/shops/" + id; }
};
function transformGetShopsResponse(data) {
    return Object.entries(data).map(function (_a) {
        var id = _a[0], name = _a[1];
        return ({ id: id, name: name, status: 'OK', modified: false });
    });
}
export function getShops() {
    return CardApiClient.get(shopUrls.getShops)
        .then(function (response) { return response.data; })
        .then(transformGetShopsResponse);
}
export function createShop(options) {
    return CardApiClient.post(shopUrls.createShop, { shop: options }).then(function (response) { return response.data; });
}
export function updateShop(id, options) {
    return CardApiClient.put(shopUrls.updateShop(id), { shop: options }).then(function (response) { return response; });
}
export function destroyShop(id) {
    return CardApiClient.delete(shopUrls.destroyShop(id)).then(function (response) { return response; });
}
